import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { IWorker } from '../workers.interface';
import { WorkersService } from '../workers.service';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';

let self: any;

@Component({
  selector: 'app-workers-modal',
  templateUrl: './workers-modal.component.html',
  styleUrls: ['./workers-modal.component.css']
})
export class WorkersModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  showEdit: boolean = true;
  loading: boolean = false;
  saving: boolean = false;
  worker!: IWorker;
  form!: UntypedFormGroup;
  submitted = false;
  isDev!: boolean;
  createUser: boolean = true;

  constructor(
    public _WorkersService: WorkersService,
    private _dialogService: DialogService,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private ref: ChangeDetectorRef,
    private _AuthService: AuthService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.isDev = this._AuthService.isRole('dev');
    if (this.worker._id) this.getWorker();
    else {
      this.buildForm();
    }
  }

  getWorker() {
    this.loading = true;
    this._WorkersService.getWorker(this.worker._id as string).subscribe((worker) => {
      this.worker = worker;
      this.buildForm();
      this.loading = false;
    });
  }

  get f() { return this.form.controls; }
  buildForm() {

    let phones: any[] = [];
    let emails: any[] = [];
    // let dob;

    if (this.worker.phones) {
      this.worker.phones.forEach((element: any) => {
        phones.push(this.newPhone(element.type, element.number));
      });
    }

    if (this.worker.emails) {
      this.worker.emails.forEach((element: any) => {
        emails.push(this.newEmail(element.type, element.address));
      });
    }

    /*
    if (this.worker.dob) {
      dob = new Date(this.worker.dob).toISOString().slice(0, 10);
    }
    */

    this.form = this.fb.group({
      lastname: [this.worker.lastname, [Validators.required]],
      firstname: [this.worker.firstname, [Validators.required]],
      // dob: [dob],
      phones: this.fb.array(phones),
      emails: this.fb.array(emails),
      idn: this.worker.idn,
      isDeleted: [this.worker.isDeleted],
      username: [this.worker.username, [Validators.required]],
      createUser: this.createUser,
      password: ['Manax2024', [Validators.required]]
    });
  }

  get phones() {
    return this.form.get("phones") as UntypedFormArray
  }


  newPhone(type?: '', number?: ''): UntypedFormGroup {
    return this.fb.group({
      type: type,
      number: number,
    })
  }

  addPhone() {
    this.phones.push(this.newPhone());
  }

  removePhone(i: number) {
    this.phones.removeAt(i);
  }

  get emails() {
    return this.form.get("emails") as UntypedFormArray
  }


  newEmail(type?: '', address?: ''): UntypedFormGroup {
    return this.fb.group({
      type: type,
      address: address,
    })
  }

  addEmail() {
    this.emails.push(this.newEmail());
  }

  removeEmail(i: number) {
    this.emails.removeAt(i);
  }

  setEditable(value: boolean = false) {
    this.readOnly = value;
  }

  onSubmit() {
    this.submitted = true;
    let data: IWorker = _.cloneDeep(this.form.value);

    data.lastname = data.lastname ? data.lastname.trim() : '';
    data.firstname = data.firstname ? data.firstname.trim() : '';

    if (!this.createUser) {
      delete data.username;
      delete data.password;
    }

    const invalid = this.findInvalidControls();
    const found = invalid.find(el => el == 'firstname') || invalid.find(el => el == 'lastname');

    if (this.form.invalid && found) {
      return;
    };

    this.saving = true;
    data.company = this._AuthService.companyId();

    delete data.createUser;

    if (this.worker._id) {
      data._id = this.worker._id;
      this._WorkersService.updateWorker(data).subscribe({
        next: (worker) => {
          this.dialog.close(worker);
        }, error: err => {
          console.log(err);
          this.saving = false;
        }
      });
    } else {
      this._WorkersService.createWorker(data).subscribe({
        next: (worker) => {
          this.dialog.close(worker);
        }, error: err => {
          console.log(err);
          this.saving = false;
        }
      });
    }
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  openMovementsModal() {
    alert('en construccion');
    return;

    /*
    let config = new MatDialogConfig();
    config.width = '1700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.movementsDialogRef = this._dialog.open(TaskMovementsComponent, config);
    self.movementsDialogRef.componentInstance.worker = this.worker;

    self.movementsDialogRef.afterClosed().subscribe((result: any) => {
      self.movementsDialogRef = null;
    });
    */
  }

  cancelSubmit() {
    Object.keys(this.form.controls).forEach((key) => this.form.controls[key].setErrors(null));
    this.setEditable(true);
    if (this.worker._id) this.getWorker();
  }

}